import { createTheme } from "@mui/material/styles";
import ThemeOptions from "./themeOptions";

export const theme = createTheme(ThemeOptions("light"));

export const GRADIENT_START = "#FFD25F";
export const GRADIENT_END = "#FF5C01";
